import types from '@store/constants/fastTransferManagerConstants';

const initialState = {
  fastTransferConfig: {
    isLoading: false,
    isError: false,
    error: null,
    data: null
  }
};

const fastTransferManagerReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GETTING_FAST_TRANSFER_CONFIG:
      return {
        ...state,
        fastTransferConfig: {
          ...state.fastTransferConfig,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case types.GET_FAST_TRANSFER_CONFIG_SUCCESS:
      return {
        ...state,
        fastTransferConfig: {
          ...state.fastTransferConfig,
          isLoading: false,
          isError: false,
          error: null,
          data: payload
        }
      };
    case types.GET_FAST_TRANSFER_CONFIG_FAILURE:
      return {
        ...state,
        fastTransferConfig: {
          ...state.fastTransferConfig,
          data: null,
          isLoading: false,
          isError: true,
          error: payload
        }
      };
    case types.UPDATING_FAST_TRANSFER_CONFIG:
      return {
        ...state,
        fastTransferConfig: {
          ...state.fastTransferConfig,
          isLoading: true
        }
      };
    case types.UPDATE_FAST_TRANSFER_CONFIG_SUCCESS:
      return {
        ...state,
        fastTransferConfig: {
          ...state.fastTransferConfig,
          isLoading: false,
          data: payload
        }
      };
    case types.UPDATE_FAST_TRANSFER_CONFIG_FAILURE:
      return {
        ...state,
        fastTransferConfig: {
          ...state.fastTransferConfig,
          isLoading: false,
          isError: true,
          error: payload
        }
      };
    case types.RESET_FAST_TRANSFER_CONFIG_DATA:
      return {
        ...state,
        fastTransferConfig: {
          isLoading: false,
          isError: false,
          error: null,
          data: null
        }
      };

    default:
      return state;
  }
};

export default fastTransferManagerReducer;
